import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './social-networks.html';
import { MySiteRestService } from '@nuskin/my-site-api';
import { nuskin } from '@nuskin/ns-util';
import { MySiteApp } from '../../my-site-app';
import { NsSlottedDropdown } from '@nuskin/ns-form-elements';
/**
 * @customElement
 * @polymer
 */

export class SocialNetworks extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);

        this.selectedSocialMediaAccounts = [{}];
        this.availableSocialMediaAccounts = [];
        this.formChanged = false;
        this.maxCountOfAccounts = 4;
        this.urlRegex = /(https?:\/\/|www\.).+/g;
        this.socialMediaAccounts = [
            {
                id: 'facebook',
                name: 'Facebook',
                placeholder: 'www.facebook.com/username'
            },
            {
                id: 'vkontakte',
                name: 'Vkontakte',
                placeholder: 'www.vk.com/username'
            },
            {
                id: 'instagram',
                name: 'Instagram',
                placeholder: 'www.instagram.com/username'
            },
            {
                id: 'odnoklassniki',
                name: 'Odnoklassniki',
                placeholder: 'www.ok.ru/username'
            },
            {
                id: 'snapchat',
                name: 'Snapchat',
                placeholder: 'www.snapchat.com/username'
            },
            {
                id: 'twitter',
                name: 'Twitter',
                placeholder: 'www.twitter.com/username'
            },
            {
                id: 'pinterest',
                name: 'Pinterest',
                placeholder: 'www.pinterest.com/username'
            },
            {
                id: 'kakao-talk',
                name: 'KakaoTalk',
                placeholder: ''
            },
            {
                id: 'youtube',
                name: 'Youtube',
                placeholder: 'www.youtube.com/channel/username'
            },
            {
                id: 'g-plus',
                name: 'Google+',
                placeholder: 'www.plus.google.com/username'
            },
            {
                id: 'kakao-story',
                name: 'KakaoStory',
                placeholder: ''
            },
            {
                id: 'whatsapp',
                name: 'WhatsApp',
                placeholder: 'api.whatsapp.com/send?phone=phone_number'
            }
        ];

        this.eventsToListenTo = [
            'value-changed',
            'invalid-changed',
            'valid-changed'
        ];

        this.formFields = [];

        // pass save method to form wrapper
        this.parentNode.saveForm = this.save();
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'social-networks';
    }

    ready() {
        super.ready();
        this.addEventListener('nsDropdownSelect', this._handleSocialNetworkSelect);
        this.addEventListener('iron-select', this._handleSelectIssue);
        this.addEventListener('delete-social-account-modal-confirmation', this._handleDeleteConfirmation);
        this.getAvailableSocialMediaAccounts();

        this.addEventListener('dom-change', () => {
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.listenToFormChanges();
            }, 300);
        })
    }

    connectedCallback() {
        this.mySite = document.querySelector(MySiteApp.is);
        this.mySite.addEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
    }

    // listen to data changes and apply them to the form
    _subscribeToMySiteDataChanges(){
        if(this.mySite.currentForm !== SocialNetworks.is) return;
        this.set('data', this.mySite.mySiteData);
        let accounts = this.data && this.data.socialAccounts ? this.data.socialAccounts.slice(0) : [];
        // reset object references
        accounts = accounts.map(item => {
            return Object.assign({}, item)
        })
        this.set('selectedSocialMediaAccounts', []);
        this.set('selectedSocialMediaAccounts', accounts);
        // if we just removed 4th social media we need to populate an empty form at the bottom of the list
        if(!this.data.socialAccounts || this.data.socialAccounts && this.data.socialAccounts.length < this.maxCountOfAccounts
        && !this.selectedSocialMediaAccounts.find(item => !item.id)) {
        // Add empty dropdown to the bottom of the list
            this.push('selectedSocialMediaAccounts',{});
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.formFields.forEach(field => {
            this.eventsToListenTo.forEach(event => {
                field.removeEventListener(event, this.parentNode.formChanged);
                field.removeEventListener('focused-changed', this.parentNode.formTouched);
            });
        });
        this.mySite.addEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
        this.mySite.removeEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
    }

    // must be present to allow _valueChangeHandler to run validation check
    getFormFields() {
        this.formFields = this.$.socialAccounts.querySelectorAll('ns-input');
    }

    // must be present to allow `form-wrapper` to save the form
    save() {
        let that = this;
        return function () {
            // remove trailing empty entry
            let data = that.selectedSocialMediaAccounts.filter(item => item.id);
            // GA
            try {
                nuskin.events.publish(nuskin.events.mySite.SECTION_DATA_UPDATE, {
                    mySite: {
                        section: SocialNetworks.is,
                        changed: data
                    }
                });
            } catch(err) {console.log(err)}
            // store
            return MySiteRestService.setSocialMediaAccounts(data);
        }
    }

    listenToFormChanges() {
        this.getFormFields();
        this.disconnectedCallback();
        this.formFields.forEach(field => {
            this.eventsToListenTo.forEach(event => {
                field.addEventListener(event, this.parentNode.formChanged);
                field.addEventListener('focused-changed', this.parentNode.formTouched);
            });
        });

        // this handles closing previous dropdown when new one is being toggled;
        this.listenForOpenedDropdowns();
    }

    listenForOpenedDropdowns() {
        let dropdowns = this.$.socialAccounts.querySelectorAll(NsSlottedDropdown.is);
        dropdowns.forEach(item => {
            item.removeEventListener('opened-changed', this._handleOpenedDropdown.bind(this));
            item.addEventListener('opened-changed', this._handleOpenedDropdown.bind(this));
        });
    }

    _handleDeleteConfirmation(e){
        this.deleteAccount(e.detail);
    }

    /**
   * This is done to fix the issue where slotted dropdown doesn't clear our `iron-selected` class on a previously selected item inside the dropdown list.
   * The issue doesn't happen when slotted dropdown is outside of the dom-repeat, so I treat this issue as a unique case
   */
    _handleSelectIssue(e) {
        this.formChanged = true;
        if(e.currentTarget.localName === SocialNetworks.is) {
            let target = e.detail.item;
            let items = target.parentElement.children;
            Object.keys(items).forEach(i => {
                if(parseInt(target.dataset.index, 10) !== i*1)
                    items[i].className = items[i].className.split(' iron-selected').join('');
            });
        }
    }

    processSelect(e) {
        let index = e.currentTarget.dataset.index;
        let value = e.currentTarget.dataset.value;
        let socAcc = this.selectedSocialMediaAccounts.slice();
        socAcc.splice(index, 1, JSON.parse(value));
        this.set('selectedSocialMediaAccounts', socAcc);
        this.parentNode.updateAndNotify(this.selectedSocialMediaAccounts, false, false, 'socialAccounts');
    
        this.parentNode.formTouched();
        this._closeDropDown(index)

        // Add empty dropdown to the bottom of the list
        if(socAcc.length < this.selectedSocialMediaAccounts.length && this.selectedSocialMediaAccounts.length < this.maxCountOfAccounts) {
            this.push('selectedSocialMediaAccounts',{});
            // hardcode form as invalid since now it has a newly added empty input
            this.parentNode.setFormValidity(false);
        }
    }

    _closeDropDown(index) {
        let dropdowns = [].slice.call(this.$.socialAccounts.querySelectorAll('ns-slotted-dropdown'));
        dropdowns.forEach(item => {
            if (item.dataset.index === index) item.close();
        })
    }

    // close previously opened dropdown
    _handleOpenedDropdown(e) {
        let currentDropdown = e.target;
        // convert NodeList to Array
        let dropdowns = [].slice.call(this.$.socialAccounts.querySelectorAll('ns-slotted-dropdown'));
        let twoDropdownsAreOpened = dropdowns.filter(d => d.opened).length > 1;
        if(twoDropdownsAreOpened) {
            dropdowns.forEach(item => {
                if(item.dataset.index !== currentDropdown.dataset.index) item.close();
            });
        }
    }



    getCaptionPart(index) {
        return index ? 'Another' : 'Your';
    }

    getDeleteClass(item) {
        return item.id ? '' : 'inactive';
    }

    deleteAccount(dataset) {
        this.parentNode.formTouched();

        let index = parseInt(dataset.id, 10);
        this.splice('selectedSocialMediaAccounts', index, 1);
        this.parentNode.updateAndNotify(this.selectedSocialMediaAccounts, false, false, 'socialAccounts');
        if(this.selectedSocialMediaAccounts.length < this.maxCountOfAccounts && !this.selectedSocialMediaAccounts.find(item => !item.id)) {
            this.push('selectedSocialMediaAccounts',{});
        }
        this.parentElement.formChanged();
        this.parentElement.formTouched();
    }

    showConfirmationModal(e) {
        let active = JSON.parse(e.target.dataset.item).id;
        if (active) {
            let parentComponent = document.querySelector(MySiteApp.is);
            parentComponent.$.deleteSocialAccountModal.toggle(e.target.dataset);
        }
    }

    needSeparator() {
        return this.selectedSocialMediaAccounts.length > 1 ? true : false;
    }

    getAvailableSocialMediaAccounts() {
        this.availableSocialMediaAccounts = [];
        Object.keys(this.content).forEach(key => {
            let match = key.split('socialMediaAccount_');
            if(match.length > 1 && this.content[key]) {
                let account = match[1];
                account = this.socialMediaAccounts.find(item => item.id === account);
                if(account) this.push('availableSocialMediaAccounts',account);
            }
        });
    }

    getUrlLabel(name) {
        return this.content.socialAccountsFormUrlLabel.replace('{socialMedia}', name);
    }

    getDropdownLabel(index) {
        return index ? this.content.socialAccountsFormAnotherDropdownLabel : this.content.socialAccountsFormFirstDropdownLabel;
    }

}

window.customElements.define(SocialNetworks.is, SocialNetworks);
